export enum FilterOperator {
  GreaterThan = 'greaterThan',
  LowerThan = 'lowerThan',
  Equal = 'equal',
}
